<div class="pm-react-search__shell">
  <div class="pm-react-search__boot" *ngIf="isBooting">
    <ion-spinner name="crescent"></ion-spinner>
  </div>

  <div class="pm-react-search__boot pm-react-search__boot--error" *ngIf="bootError">
    <div class="pm-react-search__boot-text">
      <div class="title">Unable to load</div>
      <div class="subtitle">{{ bootError }}</div>
    </div>
  </div>

  <div class="pm-react-search__host" [class.pm-react-search__host--hidden]="isBooting" #host></div>
</div>

<ion-footer>
  <app-footer-nav></app-footer-nav>
</ion-footer>
